import axios from 'axios'
import Vue from 'vue'

const state = {
  roles: localStorage.getItem('roles') ? JSON.parse(localStorage.getItem('roles')) : null,
}

const getters = {
  availableRoles: state => state.roles,
}

const mutations = {
  setRoles: (state, roles) => {
    state.roles = roles
    localStorage.setItem('roles', JSON.stringify(state.roles))
  },
  deleteRoles: state => {
    state.roles = null
    localStorage.removeItem('roles')
  },
}

const actions = {
  loadAvailableRoles: async ({ commit }) => {
    const response = await axios.get(`${Vue.prototype.$baseURL}/roles`)
    const roles = response.data.result
    commit('setRoles', roles)
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
